// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getRemoteConfig } from "firebase/remote-config";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_APIKEY ||
    window.Cypress.env("firebase_api_key"),
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTHDOMAIN ||
    window.Cypress.env("firebase_auth_domain"),
  projectId:
    process.env.REACT_APP_FIRBASE_PROJECTID ||
    window.Cypress.env("firebase_project_id"),
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGEBUCKET ||
    window.Cypress.env("firebase_storage_bucket"),
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID ||
    window.Cypress.env("firebase_messaging_sender_id"),
  appId:
    process.env.REACT_APP_FIREBASE_APPID ||
    window.Cypress.env("firebase_app_id"),
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENTID ||
    window.Cypress.env("firebase_measurement_id"),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const remoteConfig = getRemoteConfig(app);

export { auth, app, remoteConfig };
